import { render, staticRenderFns } from "./FooterSectionThree.vue?vue&type=template&id=889f3eca&scoped=true&"
import script from "./FooterSectionThree.vue?vue&type=script&lang=js&"
export * from "./FooterSectionThree.vue?vue&type=script&lang=js&"
import style0 from "./FooterSectionThree.vue?vue&type=style&index=0&id=889f3eca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889f3eca",
  null
  
)

export default component.exports